<div class="section-page">
    <div class="section-header-bar" [class.section-header-bar--scrolled]="isScrolled">
        <div class="section-header">
            <div class="section-header__title">
                <mat-icon class="section-header__icon">backup</mat-icon>
                <div>
                    <div class="section-header__heading">Fulfillment</div>
                    <div class="section-header__subtitle">Workdrive, banking, PandaDoc and Docusign documents</div>
                </div>
            </div>
        </div>
    </div>

    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab label="Workdrive">
            <div style="padding-top: 12px;">
                <ng-template matTabContent>   
                    <app-workdrive [(application)]="application" />
                </ng-template>
            </div>
        </mat-tab>

        <mat-tab label="Banking">
            <div style="padding-top: 12px;">
                <app-banking [(application)]="application"
                             (applicationChange)="onApplicationChanged($event)"
                             [(currentUser)]="currentUser" />
            </div>
        </mat-tab>

        <mat-tab label="PandaDoc">
            <div style="padding-top: 12px;">
                <app-pandadoc [(application)]="application" />
            </div>
        </mat-tab>

        <mat-tab label="Docusign">
            <div style="padding-top: 12px;">
                <ng-template matTabContent>        
                    <app-docusign [(application)]="application" 
                    (applicationChange)="onApplicationChanged($event)" [(currentUser)]="currentUser"/>            
                </ng-template>        
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
